interface TransactionItemMobileProps {
    description: string
    date: string
    impact: string
    type: string[]
    amount: number | string
    icon?: React.ReactNode
}
export function TransactionItemMobile({
    description,
    date,
    impact,
    amount,
    type,
    icon,
}: TransactionItemMobileProps) {
    return (
        <div className='flex flex-row justify-between w-full py-2'>
            <div className='flex flex-row'>
                <div className=''>{icon}</div>
                <div className='flex flex-col'>
                    <p className='m-0 text-sm font-semibold text-black'>
                        {description}
                    </p>
                    <p className='m-0 text-xs'>{date}</p>
                </div>
            </div>
            <div className='text-sm font-semibold'>
                {' '}
                {impact === 'Debit' ? '-' : ''}
                {amount}
            </div>
        </div>
    )
}
